import type { FieldStackEntry } from "./resolve-field-stack-entries";

export const isNextDisabled = (activeEntry: FieldStackEntry | undefined): boolean => {
  if (!activeEntry) return true;
  if (activeEntry.node.value.options?.disableNext === true) return true;
  return activeEntry.error !== null;
};
